/**
 * @GENERATED from Figma node 3608:51029
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const LeverDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#C3C6CC"
      fillRule="evenodd"
      d="m21.81 20.948-3.765-3.766a.636.636 0 0 0-.89 0l-3.766 3.766c-.404.404-.121 1.052.445 1.052h7.53c.567 0 .85-.688.445-1.052"
      clipRule="evenodd"
    />
    <path
      fill="#E1E3E6"
      fillRule="evenodd"
      d="M21.934 7.423 20.755 3.92c-.071-.179-.142-.322-.25-.429L2.143 21.857c.107.101.25.143.393.143h5.216c.286 0 .571-.107.786-.322L21.684 8.53c.286-.286.393-.714.25-1.107"
      clipRule="evenodd"
    />
    <path
      fill="#C3C6CC"
      fillRule="evenodd"
      d="m20.077 3.242-3.5-1.179a1.06 1.06 0 0 0-1.108.25L2.32 15.461c-.214.215-.321.5-.321.786v5.217c0 .143.042.286.143.393L20.507 3.492c-.108-.107-.252-.179-.43-.25"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(LeverDark);
export { ForwardRef as LeverDark };
